const React = require('react');


module.exports = ({
  label,
  children,
  value,
  ...props
}) => {
  return (
    <div
      {...props}
      className={'mb15 ' + (props.className || '')}
    >
      <div className="mb3 cA4A7AC f12 fw5">{label}</div>
      <div className="f16 hmin19 break">{value || children || null}</div>
    </div>
  );
};
